import React, { Component } from 'react'

import './expand.scss'

import Inline from '../inline'
import Icon from '../icon'
import { ElementIcons } from '../icons'

class Expand extends Component {
  constructor (props) {
    super(props)

    this.state = {
      open: false
    }

    this.onClick = this.onClick.bind(this)
    this.onActionClick = this.onActionClick.bind(this)
  }

  onClick () {
    this.setState({
      open: !this.state.open
    }, () => {
      if (this.props.onClick !== undefined) {
        this.props.onClick(this.state.open)
      }
    })
  }

  onActionClick (e) {
    e.stopPropagation()

    this.setState({
      open: true
    })
  }

  componentDidMount () {
    if (this.props.defaultOpen === true) {
      // this.setState({open: true})
      this.onClick()
    }
  }

  render () {
    let actions = null
    let children = this.props.children

    const firstChild = children[0]
    if (React.isValidElement(firstChild) && firstChild.type.displayName === 'Actions') {
      const [ cActions, ...rest ] = children

      actions = cActions
      children = rest
    }

    let chevronClass = 'element-expand__chevron--right'
    let contentClass = 'element-expand__content--hide'
    if (this.state.open) {
      chevronClass = 'element-expand__chevron--down'
      contentClass = ''
    }

    const renderWithActions = () => {
      return (
        <Inline fillChildNum={[2]} fullWidth>
          <h3 className='element-expand__title'>{this.props.title}</h3>
          <Icon icon={ElementIcons.Chevron_Right} className={chevronClass} injectSvg />
          <div />
          <div onClick={this.onActionClick}>{actions}</div>
        </Inline>
      )
    }

    const renderWithoutActions = () => {
      return (
        <Inline fillChildNum={this.props.alignRight ? [0] : [2]} fullWidth>
          {this.props.alignRight && <span />}
          <h3 className='element-expand__title'>{this.props.title}</h3>
          <Icon icon={ElementIcons.Chevron_Right} className={chevronClass} injectSvg />
        </Inline>
      )
    }

    return (
      <div className='element-expand'>
        <div className='element-expand__header' onClick={this.onClick}>
          {actions ? renderWithActions() : renderWithoutActions()}
        </div>

        {<div className={contentClass}>{children}</div>}
      </div>
    )
  }
}

Expand.defaultProps = {
  title: '',
  actions: [],
  rightAlignAction: false,
  alignRight: false
}

export default Expand



// WEBPACK FOOTER //
// ./src/app/shared/elements/expand/index.js